import { categories } from "@/mocks/comicData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Categories() {
  return (
    <section id="category" className="scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="按类型快速定位"
          title="漫画分类大全"
          subtitle="从热血冒险到恐怖猎奇，12 大分类随心选。人气排序与完结筛选，帮你快速圈定想看的作品。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#completed"
              className="group flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={cat.icon}></i>
              </span>
              <div className="min-w-0">
                <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                  {cat.name}
                  <span className="text-xs font-normal text-foreground-400">{cat.count}</span>
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                  {cat.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}